import type { AnalyticsPeriod, DealCountStats, DealOutcome } from "./dashboardService";
import type { LifecycleLabels } from "../../../../utils/lifecycleUtils";
import { ENTITY_ICONS } from "../entityIcons";

export const palette = {
  red: "#E41F07",
  redLight: "#FF3A22",
  area: "#F2F2F2",
  axis: "#6F6F6F",
  grid: "#E8E8E8",
};

export const revenueTabs: { key: AnalyticsPeriod; label: string }[] = [
  { key: "by_week", label: "Weekly" },
  { key: "by_month", label: "Monthly" },
  { key: "by_year", label: "Yearly" },
];

export const pipelineStageColors: Record<string, string> = {
  won: "#44BB76",
  lost: "#E8432F",
  open: "#FDAF22",
};

export const dealOutcomes: { key: DealOutcome; label: string }[] = [
  { key: "won", label: "Won" },
  { key: "lost", label: "Lost" },
  { key: "open", label: "Open" },
];

export const trafficColors = ["#2DB05D", "#3B82F6", "#F5A60F", "#8E1E9C"];

export const trafficOthersColor = "#B0B7C3";

export interface ScorecardMeta {
  icon: string;
  gradient: [string, string];
  label?: (names: LifecycleLabels) => string;
}

export const scorecardMeta: Record<string, ScorecardMeta> = {
  revenue: { icon: "moneybag", gradient: ["#E41F07", "#FF5A43"] },
  active_deals: {
    icon: ENTITY_ICONS.deal,
    gradient: ["#3F3BD9", "#6E6BF2"],
    label: (names) => `Active ${names.deals}`,
  },
  active_lead: {
    icon: ENTITY_ICONS.lead,
    gradient: ["#E0338F", "#F56CB8"],
    label: (names) => `Active ${names.leads}`,
  },
};

export const defaultScorecardMeta: ScorecardMeta = {
  icon: "ti ti-chart-bar",
  gradient: ["#06AED4", "#4FD1EA"],
};

export const currencyScorecards = ["revenue"];

export const TOP_DEALS_LIMIT = 5;

export const dealSegments: {
  key: keyof Pick<DealCountStats, "won_deals" | "open_deals" | "lost_deals">;
  label: string;
  color: string;
}[] = [
    { key: "won_deals", label: "Won", color: "#2DB05D" },
    { key: "open_deals", label: "Open", color: "#F5A60F" },
    { key: "lost_deals", label: "Lost", color: "#E41F07" },
  ];

export const avatarColorClasses = ["bg-primary", "bg-info", "bg-success", "bg-warning", "bg-purple", "bg-danger"];

export const tagClassName = (tag: string) => {
  const normalized = tag.trim().toLowerCase();
  if (normalized === "high") return "nd-tag-danger";
  if (normalized === "medium") return "nd-tag-warning";
  if (normalized === "low") return "nd-tag-success";
  return "nd-tag-purple";
};

export const statusClassName = (status: string) => {
  const normalized = status.trim().toLowerCase();
  if (normalized === "won") return "bg-success";
  if (normalized === "lost") return "bg-danger";
  return "bg-purple";
};
